import axios from "axios";
import { token } from "./token";

const BASE_URL ="https://back.registrator.ashgabat-white-city.com";
//const BASE_URL = "http://localhost:8080/";

const axiosInstance = axios.create({
  baseURL: BASE_URL,
  timeout: 10000,

  headers: {
    Authorization: "Bearer " + token(),
    Accept: "application/json",
  },
});

export { BASE_URL, axiosInstance };
